// extracted by mini-css-extract-plugin
export default {"container":"ApplySuccessModal_container__yTKqX","content":"ApplySuccessModal_content__wj2wM"};